import { styled } from '@ui/components/styled';

export const PhishNetLogo = styled('div', {
  backgroundImage: 'url("/assets/cf-logo.svg")',
  backgroundPosition: 'center',
  backgroundRepeat: 'no-repeat',
  backgroundSize: 'cover',
  height: '30vmin',
  width: '50vmin',
});

export const CloudflareLogo = styled('div', {
  backgroundImage: 'url("/assets/cf-logo-filled.png")',
  backgroundPosition: 'center',
  backgroundRepeat: 'no-repeat',
  backgroundSize: 'contain',
  height: '10vmin',
  width: '10vmin',
});
